/* eslint-disable */
import styled from '@emotion/styled';


export const TitleField = styled.h3`
    color: #111827;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.3333;
`;

export const ObjectFieldTemplate = styled.fieldset`
    border: 0;
    padding: 0;
`;
